import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-password-compromised-modal',
  templateUrl: 'password-compromised-modal.html',
})

export class PasswordCompromisedModal{

    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
      private activeModal: NgbActiveModal
    ) {}

    closeModal(isContinue:boolean){
      this.activeModal.close(isContinue);
    }
}